import { Component, OnInit, Input, OnChanges, DoCheck, Output, EventEmitter, OnDestroy, ViewChild } from '@angular/core';
import { CommonService } from 'src/app/Service/Common.service';
import { MapRoleFeatureService } from 'src/app/Service/map-role-feature/map-role-feature.service';
import { NotificationService } from 'src/app/Service/notification.service';
import * as moment from 'moment';
import { PeerReviewService } from 'src/app/Service/peerReview/peer-review.service';
import { ReviewViewComponent } from "../review-view/review-view.component";
import { MatDialog } from '@angular/material/dialog';
import { IApproveInputModel, IReviewListViewModel, IApproveReviewViewModel, DocDetailsOutput, IStatusInputModel } from 'src/app/ViewModel/PeerReviewModel';
import { DataBindingDirective, ExcelExportEvent } from '@progress/kendo-angular-grid';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { FormControl, FormGroup } from '@angular/forms';
import { Time } from '@angular/common';
import { PrInvitationComponent } from "../pr-invitation/pr-invitation.component";


const createFormGroup = (dataItem: { date: any; time_From: any; time_To: any; doc_Location: any; }) => new FormGroup({
  'date': new FormControl(dataItem.date),
  'time_from': new FormControl(dataItem.time_From),
  'time_to': new FormControl(dataItem.time_To),
  'doc_Location': new FormControl(dataItem.doc_Location)
});
@Component({
  selector: 'app-review-status',
  templateUrl: './review-status.component.html',
  styleUrls: ['./review-status.component.css']
})
export class ReviewStatusComponent implements OnInit {
  public project_Id !: number;
  public groupId !: number;
  public memberId!: number;
  isViewDoc:boolean=false;
  public enableFilter : boolean = false;
  public reviewList: IReviewListViewModel[] = [];
  public statusList: any[] = [];
  public Tabname!: string;
  public Feature!: any[];
  public ReviewList!: IReviewListViewModel[];
  public _Data:any;
  public pr_response: boolean = false;
  public pr_impacts: boolean = false;
  public ProjectTeam: boolean = false;
  public pr_comments: boolean = false;
  public edit_res_imp : boolean = false;
  public skip=20;
  public pr_status: boolean = false;
  public pr_approval: boolean = false;
  public pr_invite_feature: boolean = false;
  selected!:any;
  Roles: any[];
  editedDate!: Date;
  editedRowIndex:any = null;
  public formGroup!: FormGroup;
  public datevalue = new Date();
  public fromtime!: Time;
  public uptotime!: Time;
  public docLocation!: string;
  public sheduleFrom:string;
  public sheduleTo:string;

  public updatestatusbtn: boolean = true;


  @Input() set Data(val:any){
    if(val)
    {
      this._Data = val;
      this.filter();
    }
  } 
  get Data():any
  {
    return this._Data;
  }
  @Output() ReviewListEmitter=new EventEmitter();
  

  @ViewChild(DataBindingDirective) directive!:DataBindingDirective;
  constructor(private statusService: PeerReviewService, private dialog: MatDialog, public notificationService: NotificationService,
    private mapRoleFeatureService: MapRoleFeatureService, private commonService: CommonService) { }

  filter()
  {
    if(this._Data ){
      this.Tabname = this._Data.tabname;
      this.Feature = this._Data.Feature;
      this.ReviewList =this._Data.ReviewList;
      if (this.directive != undefined)
        this.directive.skip=0;
      this.skip = 0;
      this.isViewDoc = false;
      this.reviewList = [];
      this.enableFilter = false;
    }
  }

  ngOnInit() {
    this.project_Id = this.commonService.getProjectId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.memberId = this.commonService.getLoggedInUserId();
    this.pr_status = this.Feature.some(x => x.feature_Desc == "PR Status Update" && x.feature_Id==600004);
    this.pr_comments=this.Feature.some(x => x.feature_Desc=="PR Comments" && x.feature_Id == 600005);
    this.pr_response=this.Feature.some(x => x.feature_Desc=="PR Response And Impacts" && x.feature_Id == 600007);
    this.pr_impacts=this.Feature.some(x => x.feature_Desc=="PR Impacts" && x.feature_Id == 600006);
    this.pr_approval=this.Feature.some(x => x.feature_Desc=="PR Approval" && x.feature_Id == 600002);
    this.pr_invite_feature = this.Feature.some(x => x.feature_Desc == "PR Invitation" && x.feature_Id == 600003);
    this.commonService.getProjectMemberRoles(this.project_Id,this.groupId,this.memberId).subscribe((res:any[])=>{
      this.Roles = res;
      this.edit_res_imp = this.Roles.some(x=>x.role_Short_Desc.toUpperCase().trim()=='ECD'.toLocaleUpperCase().trim() || x.role_Short_Desc.toUpperCase().trim()=='MECD'.toLocaleUpperCase().trim());
    });  
    this.allData=this.allData.bind(this);
  }

  ngDoCheck() {
    let x:any = document.getElementById("grvEDMOrgList");
    if(this.isViewDoc)
    { x.style.display = "none"; }
    else
    { x.style.display = "block"; }
  }

  public onClickEmit()
  {
    this.ReviewListEmitter.emit(true);
  }

  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }

  editRowData({ sender, rowIndex, dataItem }:any) {
    this.updatestatusbtn = false;
    this.sheduleFrom = this.convertTo12HourFormat(dataItem.time_From);
    this.sheduleTo = this.convertTo12HourFormat(dataItem.time_To);
    this.editedDate = new Date(dataItem.date);
    if (this.editedRowIndex >= 0) {
      sender.closeRow(this.editedRowIndex);
    }
    this.editedRowIndex = rowIndex;
    this.formGroup = createFormGroup(dataItem);
    dataItem.is_approve = true;
    sender.editRow(rowIndex);
  }

  UpdateRowData({ sender, rowIndex, dataItem }:any)
  {
    // if(!this.checkfromtime())
    // {
    //   this.notificationService.showPopup("Select Time above 9:00", "Warning");
    // }
    // else if(!this.checktotime())
    // {
    //   this.notificationService.showPopup("Select Time below 18:00", "Warning");
    // }
    // else
    // {
      this.updatestatusbtn = true;
      let _input: IApproveInputModel = 
      {
        intUID: this.memberId,
        strDocNumber: dataItem.requestNo,
        dtmScheduledOn: !!this.datevalue ? this.datevalue : dataItem.date,
        tmScheduledFrom: !!this.fromtime ? this.fromtime : dataItem.time_From,
        tmScheduledUpto: !!this.uptotime ? this.uptotime : dataItem.time_To,
        strDocLocation: !!this.docLocation ? this.docLocation : dataItem.doc_Location,
        bitIsFromStatus: true,
        chrIsApproved: null,
      }
      this.statusService.PostApproveReviewDetails(_input).subscribe((data) => {
        if (data.successCode == 200) {
          this.notificationService.showToast(data.successMessage, "Success");
          this.onClickEmit();
        }
        else {
          this.notificationService.showToast(data.successMessage, "Error");
        }
        dataItem.is_approve = false;
      });
      
      sender.closeRow(rowIndex);
    }
  // }

  updatescheduledOn(event: any) {
    this.datevalue = event.value;
  }

  // updatescheduledFrom(event: any) {
  //   this.fromtime = this.getFormValue(this.formGroup, 'time_from');
  // }

  // updatescheduledUpto(event: any) {
  //   this.uptotime = this.getFormValue(this.formGroup,'time_to');
  // }
  public fromTimeSelected(time:string,type:string){
    if(type == 'shFrom'){
      this.formGroup.get('time_from').setValue(time.trim());
      this.fromtime = this.formGroup.get('time_from').value
    }else {
      this.formGroup.get('time_to').setValue(time.trim());
      this.uptotime = this.formGroup.get('time_to').value
    }
  }

  public convertTo12HourFormat(time24: string): string {
    const [hours, minutes] = time24.split(':');
  
    let period = 'AM';
    let hours12 = parseInt(hours, 10);
  
    if (hours12 >= 12) {
      period = 'PM';
      if (hours12 > 12) {
        hours12 -= 12;
      }
    }
  
    return `${hours12.toString().padStart(2, '0')}:${minutes} ${period}`;
  }


  isFromtimeInvalid : boolean = true;
  isTotimeInvalid: boolean = true;
  from_Time!: Time;

  checkfromtime()
  {
    let mintime :Time = {
      hours: 9,
      minutes: 0
    };
    let maxtime :Time = {
      hours: 17,
      minutes: 0
    };
    this.from_Time = this.getFormValue(this.formGroup, 'time_from');
    let fromtime = this.getFormValue(this.formGroup, 'time_from');
    let hr = fromtime.substr(0, 2);
    let min = fromtime.substr(3, 2);
    if(hr >= mintime.hours && hr <= maxtime.hours)
    {
      this.isFromtimeInvalid = false;
      return true;
    }
    else
    {
      this.isFromtimeInvalid = true;
      return false;
    }
  }

  checktotime()
  {
    let fromtime = this.getFormValue(this.formGroup, 'time_from');
    let from_hr = fromtime.substr(0, 2);
    let from_min = fromtime.substr(3, 2);
    let maxtime :Time = {
      hours: 17,
      minutes: 59
    };
    
    let totime = this.getFormValue(this.formGroup, 'time_to');
    let hr = totime.substr(0, 2);
    let min = totime.substr(3, 2);
    if (hr >= from_hr && hr <= maxtime.hours) 
    {
      if(hr == from_hr)
      {
        if(min > from_min)
        {
          this.isTotimeInvalid = false;
          return true;
        }
        else
        {
          this.isTotimeInvalid = true;
          return false;
        }
      }
      else
      {
        this.isTotimeInvalid = false;
        return true;
      }
    } 
    else
    {
      this.isTotimeInvalid = true;
      return false;
    } 
  }

  private getFormValue(form: FormGroup, formControlName: string): any {
    return form.get(formControlName)?.value;
  }

  cancelRowData({ sender, rowIndex, dataItem }:any){
    this.updatestatusbtn = true;
    dataItem.is_approve = false;
    sender.closeRow(rowIndex);
  }

  async GetPeerReviewEditInvite(payload: any) {
    return await this.statusService.GetPeerReviewEditInvite(payload)
      .toPromise().catch((err) => { return [] });
  }

  async openInvitation(data: any) {
    var payload = {  strDocNumber: data.requestNo,  intUID: this.commonService.getLoggedInUserId()}
    var editData = await this.GetPeerReviewEditInvite(payload)
    let dialogRef = this.dialog.open(PrInvitationComponent, {
      panelClass: 'mat-dialog-primary',
      height: '60',
      maxWidth: '60vw',
      autoFocus: false,
      disableClose: true,
      data: { requestNo: data.requestNo, document_Location: data.document_Location,editData:editData,newReqNo:data.old_Ref_Id }
    });
    dialogRef.afterClosed().subscribe(res => {
      this.onClickEmit();
    })
  }

  public saveStatus(dataItem:any) {
    if (dataItem){
      let obj = {
        ProjectId : this.commonService.getProjectId(),
        DocNum :  dataItem.requestNo ,
        DsCode : dataItem.ds_code,
        UID : this.commonService.getLoggedInUserId(),
        Schdate : dataItem.date
      }
      this.statusService.postReviewStatus(obj).subscribe(data => {
        if (data.successCode == 200) {
          this.notificationService.showToast(data.successMessage, "Success");
          //this.selected=null;
          //this.getStatus();
          this.onClickEmit();
        }
        else if (data.successCode == 205) {
          if(dataItem.ds_code==30)
          {
            this.notificationService.showToast(data.successMessage, "Warning");
          }
          else
          {
            this.notificationService.showPopup(data.successMessage, 'Confirm').then(data => {
              if (data == 'yes') 
              {
                let obj1: IStatusInputModel = {
                  ProjectId : this.commonService.getProjectId() ,
                  DocNum :  dataItem.requestNo ,
                  DsCode : dataItem.ds_code,
                  UID : this.commonService.getLoggedInUserId(),
                  Schdate : dataItem.date,
                  Confirm : '1'
                }
                this.statusService.postReviewStatus(obj1).subscribe(data => {
                  if (data.successCode == 200) {
                    this.notificationService.showToast(data.successMessage, "Success");
                    //this.selected=null;
                    // this.getStatus();
                    this.onClickEmit();
                  }
                });
              }
            });
          }
        }
      });
    }
    else {
      this.notificationService.showToast("Select an Status Update", "Warning");
    }
  }

  viewDocumentClick(dataItem:any) {
    this.isViewDoc = true;
    this.reviewList = dataItem;
  }

  closeViewTab(val:boolean) {
    if(val) {
      this.onClickEmit();
    }
    this.isViewDoc = false;
    this.reviewList = [];
  }
  

  viewPeerdoc(dataItem: any) {
    let datainput =
    {
      strDocNumber: dataItem.requestNo,
      intUID: this.memberId
    };

    this.statusService.getPeerDocView(datainput).subscribe((resDoc: DocDetailsOutput) => {
      if (resDoc) {
        let dialogRef = this.dialog.open(ReviewViewComponent,
          {
            panelClass: 'mat-dialog-primary',
            data: { docvalue: resDoc, input: datainput }
          });
        dialogRef.afterClosed().subscribe(res => {
        });
      }
    }, err => { });
  }

  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: this.ReviewList.map((data,idx)=>({
        ...data,
        review_No:data.requestNo ? data.requestNo : '',
        Date_Time:data.date ? (moment(data.date)).format('DD-MMM-yyyy')+' '+data.time_From+' - '+data.time_To:'',
        created_On:data.created_On ? (moment(data.created_On)).format('DD-MMM-yyyy'):'',
        approved_on:data.approved_on ? (moment(data.approved_on)).format('DD-MMM-yyyy'):'',
        ded_Desc:data.discipline ? data.discipline:'',
        req_Status:data.request_Status ? data.request_Status:''
      }))
    };
    return result;
  }

  public onExcelExport(e: ExcelExportEvent): void {
    e.workbook.sheets[0].columns.forEach((data: { width: number; autoWidth: boolean; textAlign: string; })=>{
      data.width=25
      data.autoWidth=true;
      data.textAlign="left"
    })
  }

}
